<template>
	<div class="text-left">
		<v-card elevation="0">
			<div class="admin-study-card-contents">
				<v-row>
					<h1 class="text-center"> Study Summary </h1>
				</v-row>
				<v-row>
					<v-btn
						class="btn-default"
						text
						@click="$emit('backToSearch')"
					>
						Back To Search
					</v-btn>
					<v-btn
						class="btn-default"
						text
						@click="copyStudy"
					>
						Copy JSON
					</v-btn>
					<v-btn
						v-if="study"
						class="btn-default"
						text
						@click="displaySSOOption = true"
						:disabled="displaySSOOption"
					>
						Configure SSO
					</v-btn>
					<v-btn
						class="btn-default"
						text
						@click="displaySearchOption = true"
					>
						Configure Search
					</v-btn>
				</v-row>
				<v-row
					v-show="displaySSOOption"
				>
					<v-text-field
							v-model="secret"
							label="Secret"
					></v-text-field>
					<v-btn
						class="btn-default"
						text
						@click="displaySSOOption = false"
						>Cancel</v-btn>
					<v-btn
						class="btn-default"
						text
						@click="handleConfigureSSO()"
						:loading="loadingConfiguration"
					>
						Submit
					</v-btn>
				</v-row>
				<v-row
					v-show="displaySearchOption"
				>
					<div>
						<h2>Version Modules</h2>
						<v-container fluid v-show="hasAvailableSearchOptions">
							<p>Version {{study ? study.version : ''}} Nutrition Database Sources</p>
							<v-checkbox
								v-model="selectednutrientDatabaseSources"
								v-for="option in availableSearchOptions"
								v-bind:key="option"
								:label="option"
								:value="option"
							></v-checkbox>
						</v-container>
						<v-container v-show="!hasAvailableSearchOptions">
							<p>Version {{study ? study.version : ''}} does not have any Nutrition Database Sources configured</p>
						</v-container>
						<v-btn
							class="btn-default"
							text
							@click="displaySearchOption = false"
							>Cancel</v-btn>
						<v-btn
							class="btn-default"
							text
							:disabled="!hasAvailableSearchOptions"
							@click="handleConfigureSearchOption"
						>
							Submit
						</v-btn>
					</div>
				</v-row>
				<v-row>
					<v-data-table
						:headers="studyHeaders"
						:items="studyForDisplay"
						:items-per-page="500"
						class="elevation-1"
						hide-default-footer
					>
						<template v-for="h in studyHeaders" v-slot:[`header.${h.value}`]="{ header }">
							<span :key="h.value" class="columnTitleText" tabIndex="0" v-on:keyup.enter="(e) => e.target.click()">{{h.text}}</span>
						</template>
					</v-data-table>
				</v-row>
				<br/>
				<v-row>
					<h1 class="text-center"> Staff List </h1>
				</v-row>
				<v-row>
					<v-data-table
						:headers="staffTableHeaders"
						:items="staff"
						:items-per-page="500"
						class="elevation-1"
						hide-default-footer
					>
						<template v-slot:[`item.actions`]="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="goToUserDetails(item)"
              >
                mdi-account-details
              </v-icon>
            </template>
					</v-data-table>
				</v-row>
			</div>
		</v-card>
	</div>
</template>
<script>
import { researcherApiService } from '@/services/researcherApiService';
import { utilityService } from '@/services/utilityService.js';
import { resolve } from 'path';
import { reject } from 'q';

export default {
	name: 'studyDetails',
	props: {
		studyInfo: String
	},
	data: () => ({
		studyId: '',
		studyName: '',
		studyUuid: '',
		studyTool: '',
		dateStart: '',
		dateEnd: '',
		version: '',
		funding: '',
		mainStudyObject: {},
		staff: [],
		staffTableHeaders: [
			{ text: 'Email', value: 'email', class: 'data-table-header' },
			{ text: 'User Name', value: 'userName', class: 'data-table-header' },
			{ text: 'User Details', value: 'actions', class: 'data-table-header', sortable: false }
		],
		study: null,
		studyHeaders: [
			{ text: 'Attribute', value: 'key', class: 'data-table-header' },
			{ text: 'Value', value: 'value', sortable: false, class: 'data-table-header' }
		],
		displaySSOOption: false,
		displaySearchOption: false,
		secret: '',
		loadingConfiguration: false,
		selectednutrientDatabaseSources: []
	}),
	mounted () {
		if (this.studyInfo) {
			const me = this;

			researcherApiService.loadStudy(this.studyInfo)
				.then(function (response) {
					me.study = response.data;
					me.study.dateStart = me.convertToDate(response.data.dateStart);
					me.study.dateEnd = me.convertToDate(response.data.dateEnd);

					// New formate Dates
					const newStartDate = me.convertToDate(response.data.dateStart)
					// console.log("newStartDate: ", newStartDate)
					const newEndDate = me.convertToDate(response.data.dateEnd)
					// console.log("newEndDate: ", newEndDate)
					me.studyId = response.data.studyId
					me.studyName = response.data.studyName
					me.studyUuid = response.data.studyUuid
					me.studyTool = response.data.studyTool
					me.description = response.data.description
					// me.dateStart = myStartDate
					// me.dateEnd = myEndDate
					me.dateStart = newStartDate
					me.dateEnd = newEndDate
					me.version = response.data.version
					me.funding = response.data.funding
					if (response.data.nutrientDatabaseSources) {
						me.selectednutrientDatabaseSources = response.data.nutrientDatabaseSources;
					} else {
						me.selectednutrientDatabaseSources = [];
					}
					me.secret = response.data.secret;
				})
				.catch(function (e) {
					console.log(e);
				});

			researcherApiService.loadStaff(this.studyInfo)
				.then(function (response) {
					// console.log('loadStudy Staff response:', response)
					// console.log('loadStudy Staff response.data:', response.data)
					// console.log('loadStudy Staff response.data.staff:', response.data.staff)

					for (const piece of response.data) {
						var staff = {
							email: piece.email,
							userName: piece.userName
						}
						me.staff.push(staff)
					}
					// // For testing multiple staff
					// me.staff.push('email1@email.com')
					// me.staff.push('email2@email.com')
					// me.staff.push('email3@email.com')
				})
				.catch(function (e) {
					console.log(e);
				});
		}
	},
	methods: {
		convertToDate (dateStr) {
			// console.log("-----------------------")
			// console.log("cht dateStr: ", dateStr)
			let d = dateStr;
			if (d.length < 15) {
				d = utilityService.normalizeEpoch(d)
			}
			d = utilityService.formatDate(d)
			// console.log("cht d: ", d)
			return d || 'N/A'
		},
		copyStudy () {
			navigator.clipboard.writeText(JSON.stringify(this.study));
		},
		handleConfigureSSO () {
			const me = this;

			this.updateStudy()
				.then(function (response) {
					if (response) {
						me.study.isRemote = response.data.isRemote;
						me.study.secret = response.data.secret;
					}
				});
		},
		handleConfigureSearchOption () {
			const me = this;

			this.updateStudy()
				.then(function (response) {
					if (response) {
						me.study.nutrientDatabaseSources = response.data.selectednutrientDatabaseSources;
					}
				});
		},
		goToUserDetails (item) {
			this.$emit('seeUserDetails', item.userName);
		},
		updateStudy () {
			const me = this;
			this.loadingConfiguration = true;

			const studyChanges = {
				studyId: this.studyUuid,
				secret: this.secret,
				isRemote: !!this.secret,
				nutrientDatabaseSources: this.selectednutrientDatabaseSources
			};

			// No need to go through the store as we are not working on the user's study set
			return researcherApiService.saveStudyAdmin(this.studyUuid, studyChanges)
				.then(function (response) {
					if (response && response.data) {
						me.loadingConfiguration = false;
						me.displaySSOOption = false;
						me.displaySearchOption = false;

						me.$store.dispatch('changeUpdateStatusWithMessage', {
							status: 'generic-success',
							message: 'Success updating the study'
						});
					}
				})
				.catch(function (e) {
					console.log(e);
					me.loadingConfiguration = false;
					me.$store.dispatch('changeUpdateStatusWithMessage', {
						status: 'generic-error',
						message: 'Error updating the study'
					});
					reject(e);
				})
		}
	},
	computed: {
		studyForDisplay: function () {
			const attributeArray = [];
			if (this.study) {
				for (const [key, value] of Object.entries(this.study)) {
					attributeArray.push({ key: key, value: value });
				}
				// Sort the attributes by key
				attributeArray.sort((a, b) => a.key.localeCompare(b.key));
			}
			return attributeArray;
		},
		availableSearchOptions: function () {
			if (this.study && this.study.version) {
				return this.$store.getters.getStudyVersion(this.study.version).nutrientDatabaseSources;
			}
			return null;
		},
		hasAvailableSearchOptions: function () {
			let options = false;
			if (this.study && this.study.version) {
				options = this.$store.getters.getStudyVersion(this.study.version).nutrientDatabaseSources;
			}
			return options && options.length > 0
		}
	}
}
</script>

<style>
.admin-study-card-contents {
  padding: 10px;
}
</style>
